import { environment } from './../../environments/environment';
import { Component, OnInit, Input, PLATFORM_ID, Inject } from '@angular/core';
import { AppService } from '../app.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { Router} from "@angular/router";


declare const $;
declare const gtag;
declare const fbq;

@Component({
  selector: 'app-leadform',
  templateUrl: './leadform.component.html',
  styleUrls: ['./leadform.component.css']
})
export class LeadformComponent implements OnInit {

  @Input() property_id;
  @Input() leadTableName;
  @Input()leadTablePropertyType;
  @Input() leadTableLookingType;
  @Input() leadpropertyIdno;
  @Input() leadPropertyPrice;
  @Input() leadPropertyTitle;
  

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private service: AppService,private router: Router, private fb: FormBuilder) { }

  contactFormShow: boolean = true;
  otpFormShow: boolean = false;
  thankYouFormShow: boolean = false;
  leadFormLoader: boolean = false;
  leadFormValid: boolean = false;
  leadFormMsg: string = "";
  errorMessage:boolean = false;
  isChecked:boolean = true;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      var leadUserData = JSON.parse(localStorage.getItem('leadform_data'));

      if (leadUserData) {
        this.leadFormData.patchValue({ "dealer_have": leadUserData.dealer_have, "contact_name": leadUserData.contact_name, "contact_email": leadUserData.contact_email, "contact_mobile": leadUserData.contact_mobile, "address": leadUserData.address });
      }
    }

    this.leadFormData.reset();
  }

  openLeadForm() {
    this.otp.reset();
    this.leadFormMsg = "";
    this.contactFormShow = true;
    this.otpFormShow = false;
    this.thankYouFormShow = false;
    this.leadFormValid = false;
    this.otpFormValid = false;
    $('#leadModal').modal('toggle');
  }


  leadFormData = this.fb.group({
    contact_name: ['', Validators.required],
    contact_email: ['', [Validators.email]],
    contact_mobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
    terms_cond: ['true']
  });

  get leadFormDataControl() { return this.leadFormData.controls; }

  showOtpMobileNo: string;
  sendOtpForLead() {
    this.leadFormValid = true;
    if (this.leadFormData.valid) {
      this.leadFormLoader = true;
      this.leadFormMsg = "";

      this.showOtpMobileNo = (this.leadFormData.value.contact_mobile).substring(6, 10);

      this.service.post('/sendOtpForPropertyLead', { "mobile": this.leadFormData.value.contact_mobile, "property_id": this.property_id, "table_name": this.leadTableName }).subscribe(
        data => {
          if (data[0].error == '0') {
            this.leadFormMsg = this.service.successMsg(data[0].msg);
            this.contactFormShow = false;
            setTimeout(function () { $('#pass1').focus() }, 100);
            this.otpFormShow = true;

            if(environment.production){
              this.service.sendEvents("CheckOut", "CheckOut", "CheckOut");
          
              fbq('track', "CheckOut" , {
                content_type: "CheckOut",
                content_title: this.router.url,
                content_value : this.leadPropertyPrice,
                content_item : "1",
              });
            }

          } else {
            this.leadFormMsg = this.service.failedMsg(data[0].msg);
          }
          this.leadFormLoader = false;
        },
        error => {
          this.leadFormMsg = this.service.failedMsg(error.errorDesc);
          this.leadFormLoader = false;
        }
      )
    }
  }

  triggerfacebookAnalytics(eventCategory,lookingType,events,ID){
    var selectedCityData = JSON.parse(localStorage.getItem('selSearchCity'));

    const eventIDs = [selectedCityData.name,ID]

    fbq(
      'init', environment.fbId, {
      'track': 'https://www.propira.com/search/leadForm'
    }
    );
    fbq('track', events , {
      content_category:eventCategory,
      content_ids:eventIDs,
      content_type: lookingType,
      content_name:this.leadPropertyTitle,
      content_value:this.leadPropertyPrice,
      content_currency:"INR",
      content_num_items:"1"
    });
  
  }


  otp = new FormControl('', [Validators.required, Validators.maxLength(6)]);

  otpFormValid: boolean = false;
  submitContact(val:any) {
    this.otpFormValid = true;
    if (this.leadFormData.valid && val.value.pass1 && val.value.pass2 && val.value.pass3) {
      this.errorMessage = false;
      this.leadFormLoader = true;
      this.leadFormMsg = "";
      var otp = (val.value.pass1) + (val.value.pass2) + (val.value.pass3)

      var data = this.leadFormData.value;
      data['otp'] = otp;
      data['property_id'] = this.property_id;
      data['lead_source_id'] = '1';
      data['table_name'] = this.leadTableName;

      localStorage.setItem('leadform_data', JSON.stringify(this.leadFormData.value));

      this.service.post('/saveLead', data).subscribe(
        data => {
          console.log(data);
          console.log(localStorage);
          if (data[0].error == '0') {
            this.leadFormMsg = data[0].msg;
            this.otpFormShow = false;
            this.thankYouFormShow = true;
            
            if (environment.production) {
                this.service.sendEvents("Purchase", "Purchase", "Purchase");
                fbq('track', "Purchase" , {
                  content_name:this.leadPropertyTitle,
                  content_ids:this.property_id,
                  content_type: "Purchase",
                  content_value: this.leadPropertyPrice,
                  content_currency: "INR",
                  content_num_items: "1",
                });

                var lookingType;
                if(this.leadTableLookingType == "1"){
                  lookingType = "Residential"
                }else if(this.leadTableLookingType == "2"){
                  lookingType = "Commercial"
                }else if(this.leadTableLookingType == "3"){
                  lookingType = "Agriculture"
                }else if(this.leadTableLookingType == "4"){
                  lookingType = "Industrial"
                }
          

                gtag('config',environment.gtagId, {
                  'page_path': 'https://www.propira.com/search/leadForm'
                });
                if(this.leadTablePropertyType === "1"){
                  this.service.sendEvents(
                    "Lead",
                    lookingType,
                    "Rent"
                  );
                  this.triggerfacebookAnalytics("Rent",lookingType,"Lead",this.leadpropertyIdno)
                }else if(this.leadTablePropertyType === "2"){
                  this.service.sendEvents(
                    "Lead",
                    lookingType,
                    "Buy"
                  );
                  this.triggerfacebookAnalytics("Buy",lookingType,"Lead",this.leadpropertyIdno)
                }else if(this.leadTablePropertyType === "3"){
                  this.service.sendEvents(
                    "Lead",
                    lookingType,
                    "Pg"
                  );
                  this.triggerfacebookAnalytics("Pg",lookingType,"Lead",this.leadpropertyIdno)
              }
            }
            if(!localStorage.getItem('currentUser')){
              $('#leadModal').modal('toggle');
               this.service.chkLogin(data[0].mobile,data[0].otp);
            }

          } else {
            this.leadFormMsg = this.service.failedMsg(data[0].msg);
          }
          this.leadFormLoader = false;
        },
        error => {
          this.leadFormMsg = this.service.failedMsg(error.errorDesc);
          this.leadFormLoader = false;
          this.errorMessage = false;
        }
      )
    }else{
      this.errorMessage = true;
    }
  }

  numberOnly(event, length = 0): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }
}

